// extracted by mini-css-extract-plugin
export var root = "G_vj";
export var wrapper = "G_qm";
export var image = "G_vk d_w d_y d_W";
export var imageWithHeight = "G_vl";
export var crop = "G_vm";
export var round = "G_vn";
export var fixedHeight = "G_vp";